const find = (state, action) => {

};

export default (state = {}, action) => {
    switch (action.type) {
        case 'combo':
            return find(undefined, action);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./reducers/combo.js